import qs from 'qs'

const fields = [
  'slug',
  'locale',

  'dateStart',
  'dateEnd',

  'title',

  'archived',

  'sortKey'
]

const sort = ['sortKey:asc']

const populate = {
  // ...queryFragmentSeo,
  // ...queryFragmentBlocks,
  // ...queryFragmentEventEntries,
  // ...queryFragmentExhibitionEntries,
  // ...queryFragmentJournalEntries,
  // ...queryFragmentPressEntries,
  // ...queryFragmentPressKitEntries,
  coverImage: true
}

export const queryProjectEntriesThumbnail = (options: QueryManyOptionsi18n) => {
  const query = qs.stringify(
    {
      locale: options?.locale || 'nl-NL',
      pagination: {
        page: options?.page || 1,
        pageSize: options?.pageSize || 100
      },
      sort: sort,
      fields: fields,
      populate: {
        localizations: {
          populate: populate
        },
        ...populate
      }
    },
    {
      encodeValuesOnly: true
    }
  )

  return `project-entries?${query}`
}
